// @flow weak

import _ from 'lodash';

export const teamMemberSaving = state => {
  return _.get(state, ['developer', 'savingStates', 'newTeamMember'], false);
};

export const teamMemberSaveError = state => {
  return _.get(state, ['developer', 'saveErrors', 'newTeamMember']);
};

export const teamMemberSavedState = state => {
  return _.pick(
    _.get(state, ['developer', 'savedStates'], {}),
    'teamMemberEmail',
    'teamMemberRole',
    'teamMemberWelcome'
  );
};

export const developerMessages = state => {
  return _.get(state, ['developer', 'messages'], []);
};
